// extracted by mini-css-extract-plugin
export default {"root":"Switch-module__[local]___TZTyE","data":"Switch-module__[local]___Hh5LX"};